'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _codingactivity = require('./codingactivity.component');

var _codingactivity2 = _interopRequireDefault(_codingactivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var codingactivityModule = _angular2.default.module('codingactivity', [_angularUiRouter2.default]).component('codingactivity', _codingactivity2.default);

exports.default = codingactivityModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/codingactivity/codingactivity.js